import { CircularProgress, Grid, Icon, Paper } from '@material-ui/core';
import React from 'react';

import { uploadIABCategoryFile } from '~/src/dash/api/console-api';
import { ModelSecondaryButton } from '~/src/dash/components/model-secondary-button';
import { ModelTopBar } from '~/src/dash/components/model-topbar';
import { Panel, Panels } from '~/src/dash/publicaUI';
import { IStore } from '~/src/dash/reducers/store';
import {
  IBaseState,
  IHistoryProps,
  IReduxActionProps,
  ISessionStateProps,
  IUserStateProps,
  IWithStylesProps,
} from '~/src/dash/types/props';
import { publicaColors } from '~/src/dash/utils/colors';
import { decorate } from '~/src/dash/utils/decorator';
import { routeName } from '~/src/dash/utils/routes';
import { SnackbarView } from '~/src/dash/views/snackbar-view';

interface IProps
  extends IWithStylesProps,
    IReduxActionProps,
    ISessionStateProps,
    IUserStateProps,
    IHistoryProps {}

interface IState extends IBaseState {
  uploading: boolean;
  snackbarMessage: string;
  snackbarError: boolean;
}

export const IABCategoryManagerView = decorate(
  {
    redux: (state: IStore) => {
      return {
        user: state.user,
        session: state.session,
      };
    },
    styles: (theme: any) => ({
      paper: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 4,
      },
      section: {
        display: 'block',
        marginBottom: theme.spacing.unit * 4,
      },
      button: {
        margin: theme.spacing.unit,
      },
    }),
    router: true,
  },
  class extends React.Component<IProps, IState> {
    state = {
      uploading: false,
      snackbarMessage: '',
      snackbarError: false,
    };

    constructor(props: IProps) {
      super(props);
    }

    handleFileSelect = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
      if (target.files && target.files.length > 0) {
        const file = target.files[0];
        target.value = '';
        this.setState({
          uploading: true,
        });
        uploadIABCategoryFile({
          name: file.name.split('.')[0],
          file,
        })
          .then((json: any) => {
            if (json.response.success) {
              this.setState({
                snackbarMessage: 'Successfully uploaded iab-category csv file',
                snackbarError: false,
                uploading: false,
                URL: json.response.url,
              });
            } else {
              this.setState({
                snackbarMessage: 'Failed to upload iab-category csv file',
                snackbarError: true,
                uploading: false,
              });
            }
          })
          .catch(() => {
            this.setState({
              snackbarMessage: 'Failed to upload iab-category csv file',
              snackbarError: true,
              uploading: false,
            });
          });
      }
    };

    snackbarClose = () => {
      this.setState({
        snackbarMessage: '',
        snackbarError: false,
      });
    };

    render() {
      const { classes, user, session, location } = this.props;
      const { pathname } = location;
      return (
        <Panels maxWidth vertical relative minWidthMain>
          <Panel
            largeHorizontalPadding
            verticalPadding
            style={{ borderBottom: `1px solid ${publicaColors.lightGray}` }}
          >
            <ModelTopBar
              title={routeName(pathname)}
              session={session}
              user={user}
              publisher={session.publisher}
              classes={classes}
              delegateElevate={true}
              currentPath={pathname}
              disableTitlePaddingLeft
            />
          </Panel>
          <Panel scroll largePadding>
            <Paper
              classes={{
                root: classes.paper,
              }}
            >
              <Grid>
                <Grid container direction='row' alignItems='center'>
                  <p>
                    Please make sure your CSV file contains only two columns: one for Adomains and
                    one for the IAB Categories that correspond to them. Examples of accepted IAB
                    Category formats are <strong>IAB3-8</strong> and <strong>IAB3</strong>.
                  </p>
                </Grid>
                <Grid item xs={12} md={3}>
                  <div className={classes.section}>
                    {
                      // @ts-ignore
                      true && (
                        <ModelSecondaryButton
                          // @ts-ignore
                          component='label'
                          startIcon={
                            <Icon style={{ fontSize: '1rem', marginLeft: '0.5rem' }}>backup</Icon>
                          }
                          disabled={this.state.uploading}
                        >
                          Upload File&nbsp;
                          {this.state.uploading && <CircularProgress size={12} />}
                          <input
                            type='file'
                            style={{ display: 'none' }}
                            accept='.csv'
                            onChange={this.handleFileSelect}
                          />
                        </ModelSecondaryButton>
                      )
                    }
                  </div>
                </Grid>
              </Grid>
            </Paper>
            <SnackbarView
              open={!!this.state.snackbarMessage}
              error={!!this.state.snackbarError}
              onClose={this.snackbarClose}
            >
              {this.state.snackbarMessage}
            </SnackbarView>
          </Panel>
        </Panels>
      );
    }
  },
);
